// @flow
import i18n from "i18next";
import k from "src/i18n/keys";

import { useSelector, useDispatch } from "react-redux";
import React, { useState, useCallback } from "react";
import Modal from "react-modal";

import Icon from "src/components/Icon";
import { Small as StyledModal, Centered } from "src/styles/modal";
import { Button, Secondary } from "src/styles/buttons";
import { setAttribute } from "src/actions/chatroom";
import { Comments as StyledComments } from "src/styles/chatroom";
import { getActiveStatus, getTemplateId } from "src/reducers";

import type { AppState, RoomId } from "src/types";

type Props = {
  showModal: boolean,
  roomId: RoomId,
  location: string,
  status: number | null,
  handleClose: Function,
};

const Comment = ({
  showModal,
  roomId,
  location,
  status,
  handleClose,
}: Props) => {
  const [comment, setComment] = useState("");
  const templateId = useSelector(({ app }) => getTemplateId(app, `${roomId}`));
  const isMobile = useSelector(
    (state: { app: AppState }) => state.app.srw.isMobile,
  );
  const active = useSelector(({ app }) =>
    status ? getActiveStatus(app, `${templateId}`, `${status}`) : null,
  );
  const dispatch = useDispatch();

  const handleChange = useCallback(
    (e: any) => {
      const { value } = e.target;
      setComment(value);
    },
    [setComment],
  );

  const handleSubmit = useCallback(
    (e: any) => {
      e.stopPropagation();
      dispatch(setAttribute(roomId, { status, comment }, location));
      handleClose();
    },
    [dispatch, location, status, roomId, comment, handleClose],
  );

  const handleSkip = useCallback(
    (e: any) => {
      e.stopPropagation();
      dispatch(setAttribute(roomId, { status, active }, location));
      handleClose();
    },
    [dispatch, location, status, roomId, handleClose],
  );

  const renderModal = () => (
    <Modal
      isOpen={showModal}
      onRequestClose={handleClose}
      parentSelector={() => document.querySelector("#comments-modal")}
    >
      <StyledComments isMobile={isMobile}>
        <h2>
          {i18n.t(k.ADDITIONAL_COMMENTS)}
          <Icon icon="close" onClick={handleClose} />
        </h2>
        <textarea
          data-cy="status-comments"
          placeholder={i18n.t(k.ENTER_ADDITIONAL_COMMENTS)}
          value={comment}
          onChange={handleChange}
          autoFocus
        />

        <div>
          <Button
            data-cy="additional-comments"
            type="button"
            disabled={comment.length === 0}
            onClick={handleSubmit}
          >
            {i18n.t(k.SUBMIT1)}
          </Button>
          <Secondary type="button" onClick={handleSkip}>
            {i18n.t(k.SKIP)}
          </Secondary>
        </div>
      </StyledComments>
    </Modal>
  );

  if (isMobile) {
    return <Centered id="comments-modal">{renderModal()}</Centered>;
  }

  return <StyledModal id="comments-modal">{renderModal()}</StyledModal>;
};

export default Comment;
